var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconRenovations48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2256_9685)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3454 24.5029H24.9087C26.4704 24.5029 20.5164 24.5029 20.5164 24.5029C19.227 24.3054 17.9375 23.0127 17.9375 21.7199V20.6426C17.9375 18.5437 17.9375 13.9634 17.9375 13.9634C17.9375 12.6707 19.227 11.3779 20.5164 11.3779H35.3454C39.8586 11.3779 42.4375 13.6941 42.4375 18.3265C42.4375 22.1868 39.8586 24.3054 35.3454 24.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8125 24.5029H25.3958C27.0666 24.5029 20.6966 24.5029 20.6966 24.5029C19.3171 24.3054 17.9375 23.0127 17.9375 21.7199V20.6426C17.9375 18.5437 17.9375 13.9634 17.9375 13.9634C17.9375 12.6707 19.3171 11.3779 20.6966 11.3779H25.8125V24.5029Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5625 21.8779H17.9375V13.1279H13.5625V21.8779Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 17.5029H13.5625",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8125 23.6279V28.0029H31.0625",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5625 37.6279H33.6875",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2898 37.6279L30.1875 24.5029H34.9602L38.0625 37.6279H33.2898Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2256_9685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconRenovations48);
export default __webpack_public_path__ + "static/media/pictogramBeaconRenovations48.dcd811f7a9aae7db8fc2664e49ab6f3b.svg";
export { ForwardRef as ReactComponent };